import { render, staticRenderFns } from "./HeldByCustoms.vue?vue&type=template&id=4f63d803&"
import script from "./HeldByCustoms.vue?vue&type=script&lang=js&"
export * from "./HeldByCustoms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports